var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 8.37402L12.4238 8.37695C12.5852 8.62576 12.8222 8.83004 13.1123 8.94824L13.2393 8.99316C13.5456 9.08657 13.8705 9.07685 14.167 8.9707L14.292 8.91992L14.3027 8.91504L16.9629 7.64648L15.04 14.7119H4.95996L3.03613 7.64648L5.69727 8.91504L5.70117 8.91699C5.98974 9.05304 6.31503 9.09188 6.62793 9.02734L6.76172 8.99316C7.11077 8.88633 7.39348 8.65863 7.57715 8.37305L7.57812 8.37402L9.99902 4.61426L12.4219 8.37402Z",
    stroke: "#FFCC29",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.047 4.41223L7.37003 8.61896L2.39844 6.70681L5.07545 15.5027H15.0186L17.6956 6.70681L13.1065 8.61896L10.047 4.41223Z",
    fill: "#FFCC29",
    stroke: "#FFCC29",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotes);
export default __webpack_public_path__ + "static/media/votes.6efa4f11cfb0e385d174b43748b0787c.svg";
export { ForwardRef as ReactComponent };